(function () {
    'use strict';
    var controllerId = 'tAttachRoleAdd';
    angular.module('app').controller(controllerId, ['$scope', 'datacontext', 'sectionMenu', '$uibModalInstance', 'tAttach', 'tAttachId', 'ruoli', 'ruoloId', 'tSourceId', 'tAttachRole', tAttachRoleAdd]);

    function tAttachRoleAdd($scope, datacontext, sectionMenu, $uibModalInstance, tAttach, tAttachId, ruoli, ruoloId, tSourceId, tAttachRole) {
        $scope.tAttachRole = {};
        $scope.tAttach = tAttach;
        $scope.ruoli = ruoli;
        $scope.tSourceId = tSourceId;


        if (typeof (tAttachRole) == 'undefined') {
            $scope.tAttachRole = {};
            $scope.tAttachRole.Id = 0;
            $scope.tAttachRole.iTags = 0;
            $scope.tAttachRole.bRead = true;
            $scope.popupTitle = 'Nuova Visibilita';
            $scope.action = 'Add';
        } else {
            $scope.tAttachRole = jQuery.extend({}, tAttachRole);
            $scope.popupTitle = 'Modifica Visibilita Id: ' + $scope.tAttachRole.Id;
            $scope.action = 'Edit';
        }

        if (tAttachId) {
            $scope.tAttachId = tAttachId;
            $scope.tAttachRole.TAttachId = tAttachId;
        }

        if (ruoloId) {
            $scope.ruoloId = ruoloId;
            $scope.tAttachRole.RoleId = ruoloId;
        }

        if (tSourceId) {
            $scope.tSourceId = tSourceId;
            $scope.tAttachRole.TSourceId = $scope.tSourceId;
        }

        $scope.getTSourceId = function (tAttachId) {
            if (!tAttachId) return;

            return $scope.tAttach.forEach(function (item_TA) {
                if (item_TA.Id == tAttachId)
                    $scope.tAttachRole.TSourceId = item_TA.TSourceId;
            })

            return true;
        }

        $scope.setRead = function (value) {
            return value = !value;
        }


        $scope.ok = function (isValid) {
            if (isValid) {
                var result = addItem($scope.tAttachRole)
                $uibModalInstance.close(result);
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function addItem(item) {
            if ($scope.action == 'Add') {
                return datacontext.tAttachVisibility_add(item).then(function (data) {
                    return data;
                });
            } else if ($scope.action == 'Edit') {
                return datacontext.tAttachVisibility_update(item).then(function (data) {
                    return data;
                });
            }
        }
    }
})();